import { render, staticRenderFns } from "./ServicePlaceRegisterForm.vue?vue&type=template&id=4b5c7c1d&scoped=true&"
import script from "./ServicePlaceRegisterForm.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c7c1d",
  null
  
)

export default component.exports